import angular from 'angular';
import NavbarComponent from './navbar.component';

export default angular
  .module('verifyApp.navbar', [])
  .component('navbar', NavbarComponent)
  .name;



// WEBPACK FOOTER //
// ./client/components/navbar/index.js